import React from "react";
import DeviceStock from "../../containers/deviceSales/stock/deviceSalesStock";
import DeviceSalesDistribution from "../../containers/deviceSales/distribution/deviceSalesDistribution";
import Box from "./box";
import Spinner from "../../components/presentationals/Spinner";
import { isEmptyObject } from "../../utils/common/index";
import Sales from "../../containers/deviceSales/sales/index";

class DeviceSalesViews extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      flippped: [0, 0, 0], //1.dist 2.sale 3.stock
      stocksBar: "LYF",
      innerBody: {
        brandType: "OWN",
        spart: "BA",
        brandDescr: "LYF",
        model: "null",
      },
      tab: "",
      card: "",
    };
  }

  componentDidMount() {
    // let obj = {
    //     role: this.props.filterValue.selectedPartnerRoleType,
    //     "jwttoken": exportJwt(),
    //     "SAN": this.props.filterValue.SAN
    // }
    // this.props.triggerFetchAllEndPoints(obj);
  }

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //     if (this.props.filterValue.selectedRole !== nextProps.filterValue.selectedRole) {
  //         this.props.triggerFetchAllEndPoints({
  //             "Content-Type": "application/json",
  //             "role": nextProps.filterValue.selectedPartnerRoleType,
  //             "jwttoken": exportJwt(),
  //             "SAN": nextProps.filterValue.SAN
  //         });
  //     }
  //     if ((this.props.startDate !== nextProps.startDate) || (this.props.endDate !== nextProps.endDate) || (this.props.filterValue !== nextProps.filterValue)) {
  //         this.setState({
  //             flippped: [0, 0, 0]
  //         })
  //     }
  // }

  onClickHandlerStock = (index) => {
    ({
      0: () => {
        this.setState({
          stocksBar: "LYF",
          innerBody: {
            brandType: "OWN",
            spart: "BA",
            brandDescr: "LYF",
            model: "null",
          },
        });
      },
      1: () => {
        this.setState({
          stocksBar: "Jio-Fi",
          innerBody: {
            brandType: "OWN",
            spart: "BA",
            brandDescr: "JI0",
            model: "null",
          },
        });
      },
      2: () => {
        this.setState({
          stocksBar: "JioPhone",
          innerBody: {
            brandType: "OWN",
            spart: "BA",
            brandDescr: "LYF",
            model: "JIOPHONE",
          },
        });
      },
      3: () => {
        this.setState({
          stocksBar: "Accessories",
          innerBody: {
            brandType: "RECONNECT",
            spart: "BC",
            brandDescr: "null",
            model: "JIOPHONE",
          },
        });
      },
      4: () => {
        this.setState({
          stocksBar: "Jio Phone Next",
          innerBody: {
            brandType: "OWN",
            spart: "BA",
            brandDescr: "null",
            model: "null",
          },
        });
      },
    })[index]();
  };

  render() {
    if (
      this.props.getAllAPI &&
      !isEmptyObject(this.props.getAllAPI.data) &&
      this.props.getAllAPI.data.content &&
      this.props.getAllAPI.data.content[0]
    ) {
      const sales =
        this.props.getAllAPI &&
        this.props.getAllAPI.data &&
        this.props.getAllAPI.data.content
          ? this.props.getAllAPI.data.content
              .filter(
                (item) => item.moduleName.toLowerCase() === "device sales"
              )[0]
              .modSecMasterTxDtos.filter(
                (section) => section.sectionName.toLowerCase() === "sales"
              )[0]
          : {};
      const distributionModel =
        this.props.getAllAPI &&
        this.props.getAllAPI.data &&
        this.props.getAllAPI.data.content
          ? this.props.getAllAPI.data.content
              .filter(
                (item) => item.moduleName.toLowerCase() === "device sales"
              )[0]
              .modSecMasterTxDtos.filter(
                (section) =>
                  section.sectionName.toLowerCase() === "distribution"
              )[0]
          : {};
      const stockModel =
        this.props.getAllAPI &&
        this.props.getAllAPI.data &&
        this.props.getAllAPI.data.content
          ? this.props.getAllAPI.data.content
              .filter(
                (item) => item.moduleName.toLowerCase() === "device sales"
              )[0]
              .modSecMasterTxDtos.filter(
                (section) => section.sectionName.toLowerCase() === "stock"
              )[0]
          : {};
      const moduleName =
        this.props.getAllAPI &&
        this.props.getAllAPI.data &&
        this.props.getAllAPI.data.content
          ? this.props.getAllAPI.data.content.filter(
              (item) => item.moduleName.toLowerCase() === "device sales"
            )[0].moduleName
          : "";

      let tstamp = null;
      if (this.props.timestamp && this.props.timestamp[moduleName]) {
        tstamp = this.props.timestamp[moduleName]["Device Sales"];
      }
      return this.props.getAllAPI.data.content[0].isModuleActive === "Y" ? (
        <>
          {distributionModel && (
            <>
              <DeviceSalesDistribution
                data={distributionModel}
                headerSelectedDateFrom={this.props.startDate}
                headerSelectedDateTo={this.props.endDate}
                moduleName={moduleName}
                filterValue={this.props.filterValue}
                timeStampArr={tstamp}
                viewName={distributionModel?.sectionName}
              />
            </>
          )}
          {sales && (
            <>
              {sales.isSectionActive === "Y" ? (
                <Sales
                  data={sales.secTilesMasterTxDtos}
                  section={sales.sectionName}
                  filterValue={this.props.filterValue}
                  startDate={this.props.startDate}
                  endDate={this.props.endDate}
                  moduleName={moduleName}
                  timeStampArr={tstamp}
                  viewName={sales.sectionName}
                />
              ) : null}
            </>
          )}

          {stockModel && (
            <Box my={2} className={"sales"}>
              <DeviceStock
                stockModel={stockModel}
                filterValue={this.props.filterValue}
                headerSelectedDateFrom={this.props.startDate}
                headerSelectedDateTo={this.props.endDate}
                moduleName={moduleName}
                timeStampArr={tstamp}
                viewName={stockModel.sectionName}
              />
            </Box>
          )}
        </>
      ) : null;
    } else {
      if (this.props.getAllAPI && this.props.getAllAPI.loading) {
        return <Spinner />;
      } else {
        return (
          <div
            className="whitebox wow fadeInUp"
            data-wow-delay=".6s"
            data-wow-duration="0.7s"
          >
            Unable to fetch data
          </div>
        );
      }
    }
  }
}

export default DeviceSalesViews;
